import { resolveDocumentNameAbbreviation } from "../pages/client/AllEquipments/CommonFeatures/DCSTab/Table/Dashboard/docListAPI";

/**
 * Which tab of PV's Estimation a Document Register row stands for.
 *
 * A document filed under a PV revision can BE one of that revision's
 * Estimation tabs - an Estimation Summary is the Main Estimation table, a BOM
 * is the Main BOM one - rather than just sitting beside it. That pairing is
 * kept here because two places need the same answer: the projects tree, where
 * clicking such a document opens the tab it stands for, and the PV header,
 * which reports the document backing the tab currently open.
 *
 * Keyed by document identifier code (see abbreviation.json), upper-cased the
 * way resolveDocumentNameAbbreviation hands it back. Anything not listed here
 * is an ordinary document: it belongs to no tab, and both callers treat it as
 * such rather than guessing.
 */
const PV_DOC_ESTIMATION_TABS = {
  ESUM: "Main Estimation", // Estimation Summary
  BOM: "Main BOM", // Bill of Materials
  EBOM: "Main BOM", // Estimation BOM
};

/** The Estimation tab a document stands for, or null for any other document. */
export const pvEstimationTabForDocument = (doc) => {
  const code = resolveDocumentNameAbbreviation(
    doc?.documentName ?? doc?.uid ?? doc?.department ?? "",
  );
  return PV_DOC_ESTIMATION_TABS[String(code).toUpperCase()] ?? null;
};

/**
 * The document backing one Estimation tab of one revision, from a WBS's
 * register rows - the register allows an identifier once per WBS revision, so
 * there is at most one.
 *
 * @param {Array} documents  that WBS's Document Register rows
 * @param {{ revision: string|number, tabLabel: string }} scope
 */
export const findPvEstimationDoc = (documents, { revision, tabLabel } = {}) => {
  if (!Array.isArray(documents) || !tabLabel) return null;

  const wanted = String(revision ?? "").trim();
  return (
    documents.find(
      (doc) =>
        String(doc?.revision ?? "").trim() === wanted &&
        pvEstimationTabForDocument(doc) === tabLabel,
    ) ?? null
  );
};
